import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import type { HubCtaBandSection, HubSectionComponentProps } from './types'

export function HubCtaBand({
  section,
}: HubSectionComponentProps<HubCtaBandSection>) {
  return (
    <section
      id={section.id}
      className='flex flex-col items-start gap-4 rounded-2xl border border-border bg-accent px-6 py-6 md:flex-row md:items-center md:justify-between md:px-8'
    >
      <div className='flex min-w-0 flex-col gap-1'>
        {section.eyebrow && (
          <p className='text-xs font-semibold uppercase tracking-wide text-ds-text-quaternary'>
            {section.eyebrow}
          </p>
        )}
        {section.title && (
          <h2 className='text-balance font-display text-2xl font-bold leading-8 text-foreground'>
            {section.title}
          </h2>
        )}
        {section.dek && (
          <p className='text-base leading-6 text-foreground-secondary'>
            {section.dek}
          </p>
        )}
      </div>

      <div className='flex flex-wrap items-center gap-3'>
        <Link
          href={section.primary.href}
          className='inline-flex items-center gap-1 rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-background hover:opacity-90'
        >
          {section.primary.label}
          <ArrowRight className='size-4' aria-hidden />
        </Link>
        {section.secondary && (
          <Link
            href={section.secondary.href}
            className='inline-flex items-center gap-1 text-sm font-semibold text-info-700 hover:underline'
          >
            {section.secondary.label}
            <ArrowRight className='size-4' aria-hidden />
          </Link>
        )}
      </div>
    </section>
  )
}
